<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_1">Contents</h2>
<p class="firstverse"><a href="#/Text/ABetterFreedom">A Better Freedom</a></p>
<p class="firstverse"><a href="#/Text/Introduction">Introduction</a></p>
<p class="firstverse"><a href="#/Text/PartOne">Part One: Beginning a Journey</a></p>
<p class="firstverse"><a href="#/Text/Chap1">1: My Master</a></p>
<p class="firstverse"><a href="#/Text/Chap2">2: A Better Freedom</a></p>
<p class="firstverse"><span href="#/Text/Chap3" title="Link target outside of Sample">3: One Word, Three Worlds</span></p>
<p class="firstverse"><span href="#/Text/PartTwo" title="Link target outside of Sample">Part Two: Becoming Slaves of Christ</span></p>
<p class="firstverse"><span href="#/Text/Chap4" title="Link target outside of Sample">4: I, Paul, a Slave of Christ</span></p>
<p class="firstverse"><span href="#/Text/Chap5" title="Link target outside of Sample">5: My Son, Onesimus</span></p>
<p class="firstverse"><span href="#/Text/Chap6" title="Link target outside of Sample">6: Eye-Slaves and People-Pleasers</span></p>
<p class="firstverse"><span href="#/Text/Chap7" title="Link target outside of Sample">7: Your Father’s Name</span></p>
<p class="firstverse"><span href="#/Text/Chap8" title="Link target outside of Sample">8: Don’t Worry About It</span></p>
<p class="firstverse"><span href="#/Text/Chap9" title="Link target outside of Sample">9: Freed From and Freed To</span></p>
<p class="firstverse"><span href="#/Text/PartThree" title="Link target outside of Sample">Part Three: Encountering Christ the Slave</span></p>
<p class="firstverse"><span href="#/Text/Chap10" title="Link target outside of Sample">10: Christ the Slave</span></p>
<p class="firstverse"><span href="#/Text/Chap11" title="Link target outside of Sample">11: Slaves Who Waited for the Way</span></p>
<p class="firstverse"><span href="#/Text/Chap12" title="Link target outside of Sample">12: Parables of Slavery</span></p>
<p class="firstverse"><span href="#/Text/Chap13" title="Link target outside of Sample">13: The Servant Savior</span></p>
<p class="firstverse"><span href="#/Text/Chap14" title="Link target outside of Sample">14: The Death of a Slave</span></p>
<p class="firstverse"><span href="#/Text/Chap15" title="Link target outside of Sample">15: Breakfast with a Wounded Slave</span></p>
<p class="firstverse"><span href="#/Text/Chap16" title="Link target outside of Sample">16: Capture Me, for I Am Fleeing</span></p>
<p class="firstverse"><span href="#/Text/Epilogue" title="Link target outside of Sample">Epilogue: <em>Freedom</em></span></p>
<p class="firstverse"><span href="#/Text/Coda" title="Link target outside of Sample">Coda by Sara Groves</span></p>
<p class="firstverse"><span href="#/Text/AppendixA" title="Link target outside of Sample">Appendix A: <em>A Comparison of the Three Worlds of Slavery</em></span></p>
<p class="firstverse"><span href="#/Text/AppendixB" title="Link target outside of Sample">Appendix B: <em>A Lexicon of Slavery</em></span></p>
<p class="firstverse"><span href="#/Text/AppendixC" title="Link target outside of Sample">Appendix C: <em>A List of Possible Slaves in the New Testament</em></span></p>
<p class="firstverse"><span href="#/Text/AppendixD" title="Link target outside of Sample">Appendix D: <em>The Slave Parables</em></span></p>
<p class="firstverse"><span href="#/Text/AppendixE" title="Link target outside of Sample">Appendix E: <em>The Facts of Modern Slavery</em></span></p>
<p class="firstverse"><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstverse"><span href="#/Text/Bibliography" title="Link target outside of Sample">Bibliography </span></p>
<p class="firstverse"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
<p class="firstverse"><span href="#/Text/MoreTitlesfromIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?27d1539c